<template>
    <div>
        <page-header :user="user"></page-header>
        <main role="role">
            <!-- 主頁內容都放在 main 裡面-->
            <h1 class="mx-auto" style="text-align:center">{{$t('element_speaking.themeOrientedClassesＭ')}}</h1>
            <div class="series-title container d-flex mb-3" style="position:relative;">

                <div class="my-class my-auto">

                </div>
            </div>
            <focusing-class-ad tag-label="'speaking_home'"></focusing-class-ad>
            <section class="mb-3" style="text-align:center;">
                <h3>{{$t('element_speaking.otherClasses')}}</h3>
                <div class="container row mx-auto" style="padding-bottom:3rem;">
                    <!-- eslint-disable-next-line -->
                    <div v-for="sitem in classSeries" class="class-series col-md-4 px-2 mt-3" :key="sitem.Name">
                        <div class="card h-100">
                            <img class="card-img-top" :src="fmtSeriesVideoImage(sitem)" alt="Card image cap">
                            <div class="card-body text-black-50 d-flex flex-column">
                                <div class="flex-grow-1 mb-0 d-flex flex-column">
                                    <div class="text-left flex-grow-1">
                                        <p class="card-text mb-0">{{sitem.Name}}</p>
                                        <p class="card-text mb-0">{{$t('element_speaking.teacher')}} {{sitem.HosterName}}</p>
                                        <p v-if="sitem.ExpectedStartDate" class="card-text mb-0">{{$t('element_speaking.classesStartTime')}} {{sitem.ExpectedStartDate}}</p>
                                        <p class="card-text mb-0">{{$t('element_speaking.classesNum')}} {{sitem.ClassCount}}</p>
                                        <span v-if="sitem.IsSubscribed" class="badge badge-pill badge-warning">{{$t('element_speaking.subscribed')}}</span>
                                    </div>
                                    <div>
                                        <button :class="fmtSeriesButtonStyle(sitem)"
                                                v-on:click="gotoSeriesList(sitem)">
                                            {{fmtSeriesGotoButton(sitem)}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <a class="my-auto mb-3 mx-auto" style="text-decoration:underline;color: cornsilk;"
                   href="/Speaking/About">{{$t('element_speaking.aboutTOC')}} >></a>
            </section>
        </main>
        <page-footer></page-footer>
        <v-dialog style="color: black; z-index: 99999;" height="auto" :scrollable="true" :click-to-close="false" />
    </div>
</template>

<script>
    import appMixin from '@/lib/AppBaseMixin.js';

    import Vue from 'vue'
    import PageHeader from '@/components/Elements/PageHeader.vue';
    import PageFooter from '@/components/Elements/PageFooter.vue';

    import VModal from 'vue-js-modal';
    import 'vue-js-modal/dist/styles.css'
    Vue.use(VModal, { dialog: true });

    import FocusingClassAd from '@/components/FocusingClassAd.vue'

    import axios from 'axios'
    import VueAxios from 'vue-axios'
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = process.env.VUE_APP_OLD_SERVER_BASE_URL;
    //Vue.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';

    Vue.use(Loading);

    export default {
        name: 'App',
        mixins: [appMixin],
        components: {
            'focusing-class-ad': FocusingClassAd,
            PageHeader,
            PageFooter,
        },
        data: function () {
            return {
                // series data
                classSeries: null,
            };
        },
        methods: {
            loadIncomingClassSeries: function () {
                var loader = Vue.$loading.show();
                Vue.axios.get('Speaking/GetIncomingClassSeries')
                    .then(res => {
                        var data = res.data;
                        if (data.success) {
                            this.classSeries = data.data;
                        } else if (data.success == false) {
                            this.alert(data.message);
                        }
                        loader.hide();
                    })
                    .catch(error => {
                        if (error.response) {
                            // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                            // 有 data / status / headers 參數可用
                            console.log(error.response.status)
                        } else if (error.request) {
                            // 發送請求，但沒有接到回應
                            // error.request is an instance of XMLHttpRequest in the browser
                            // and an instance of http.ClientRequest in node.js
                            console.log(error.request)
                        } else {
                            // 在設定 request 時出錯會進入此
                            console.log('Error', error.message)
                        }
                        this.alert('無法取得系列課程資料。發生不知名的錯誤');
                        loader.hide();
                    });
            },
            gotoSeriesList: function (sitem) {
                if (sitem.AdUrl) {
                    location.href = sitem.AdUrl;
                } else {
                    var appUrl = process.env.VUE_APP_OLD_SERVER_BASE_UR + '/Speaking/ClassHistory';

                    location.href = appUrl + '/' + sitem.HashedId + '?m=sc';
                }

            },
            fmtSeriesButtonStyle: function (sc) {
                var style = ['btn', 'btn-sm', 'mt-2'];
                if (sc.AdUrl) {
                    style.push('btn-success');
                } else {
                    style.push('btn-primary');
                }

                return style;
            },
            fmtSeriesVideoImage: function (cs) {
                if (cs && cs.VideoId) {
                    return 'http://img.youtube.com/vi/' + cs.VideoId + '/mqdefault.jpg';
                } else {
                    return '/Content/classroom.jpg';
                }
            },
            fmtSeriesGotoButton: function (sc) {
                if (sc.AdUrl) {
                    return '查看課程規劃';
                } else {
                    return '查看課程影片';
                }
            },
            initData: function () {
                this.loadIncomingClassSeries();
            },
        },  // end of methods
        computed: {

        },
        mounted: function () {
            this.initData();
        },
        watch: {
        },
        created() {
        },
    }
</script>

<style>
</style>
